import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";
import { media } from "../Utils/media";
import aboutTopBG from "../Assets/Images/aboutTopBG.jpg";
import aboutBg2 from "../Assets/Images/aboutBg2.png";
import aboutImg1 from "../Assets/Images/aboutImg1.svg";
import aboutImg2 from "../Assets/Images/aboutImg2.svg";
import aboutImg3 from "../Assets/Images/aboutImg3.svg";
import aboutImg4 from "../Assets/Images/aboutImg4.svg";
import about4bg from "../Assets/Images/about4bg.png";
import aboutArrow1 from "../Assets/Images/aboutArrow1.svg";
import aboutArrow2 from "../Assets/Images/aboutArrow2.svg";
import { fluidFont } from "../Utils/fontSize";

const About = () => {
  useEffect(() => {
    AOS.init({});
  }, []);
  const canvasRef = useRef(null);
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  function scaleBetweenWidth(minWidth, maxWidth, minValue, maxValue) {
    const width = window.innerWidth;
    if (width <= minWidth) return minValue;
    if (width >= maxWidth) return maxValue;

    // 선형 보간 (linear interpolation)
    return minValue + ((width - minWidth) / (maxWidth - minWidth)) * (maxValue - minValue);
  }

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const requestAnimFrame =
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      ((callback) => window.setTimeout(callback, 1000 / 60));

    class particle {
      constructor(x, y, distance) {
        this.angle = Math.random() * 2 * Math.PI;
        this.radius = Math.random() * (isMobile ? 1 : 3);
        this.opacity = (Math.random() * 5 + 2) / 10;
        this.distance = (1 / this.opacity) * distance;
        const SPEED_MULTIPLIER = isMobile ? 5 : 1;
        this.speed = this.distance * 0.00003 * SPEED_MULTIPLIER;

        this.position = {
          x: x + this.distance * Math.cos(this.angle),
          y: y + this.distance * Math.sin(this.angle),
        };

        this.draw = () => {
          ctx.fillStyle = `rgba(255,255,255,${this.opacity})`;
          ctx.beginPath();
          ctx.arc(this.position.x, this.position.y, this.radius, 0, Math.PI * 2);
          ctx.fill();
          ctx.closePath();
        };

        this.update = () => {
          this.angle += this.speed;
          this.position = {
            x: x + this.distance * Math.cos(this.angle),
            y: y + this.distance * Math.sin(this.angle),
          };
          this.draw();
        };
      }
    }

    class eemitter {
      constructor(x, y) {
        this.position = { x, y };
        this.radius = scaleBetweenWidth(320, 1920, 50, 100);
        this.count = Math.floor(scaleBetweenWidth(320, 1920, 3000, 5000));
        this.particles = [];

        for (let i = 0; i < this.count; i++) {
          this.particles.push(new particle(this.position.x, this.position.y, this.radius));
        }

        this.draw = () => {
          ctx.fillStyle = "rgba(0,0,0,1)";
          ctx.beginPath();
          ctx.arc(this.position.x, this.position.y, this.radius, 0, Math.PI * 2);
          ctx.fill();
          ctx.closePath();
        };

        this.update = () => {
          for (let i = 0; i < this.count; i++) {
            this.particles[i].update();
          }
          this.draw();
        };
      }
    }

    const emitter = new eemitter(canvas.width / 2, canvas.height / 2);

    const loop = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      emitter.update();
      requestAnimFrame(loop);
    };

    loop();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);

  return (
    <PageContainer>
      <TopSection>
        <TopSectionTitleArea>
          <TopSectionTitleContainer>
            <TopSectionTitleCopy data-aos="fade-right" data-aos-delay="200" data-aos-duration="1400">
              ABOUT US
            </TopSectionTitleCopy>
          </TopSectionTitleContainer>
        </TopSectionTitleArea>
        <TopSectionBG />
      </TopSection>
      <Section1Container data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
        <Section1Title>
          <Section1TitleCopy>
            기획에서 시작되는 <SquareText>무한한 확장</SquareText>
          </Section1TitleCopy>
          <Section1BodyCopy>기획이 단순한 전략이 아니라, 콘텐츠와 경험을 통해{isMobile && <br />}사람들이 느끼고 연결되는 미래를 창조한다.</Section1BodyCopy>
        </Section1Title>
        <Section1CanvasWrapper>
          <Section1Canvas ref={canvasRef} id="particle"></Section1Canvas>
        </Section1CanvasWrapper>
      </Section1Container>
      <Section2BG>
        <Section2Container>
          <Section2TitleCopy data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
            Our <StrokeText>Philosophy</StrokeText>
          </Section2TitleCopy>
          <Section2Image data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
            {isMobile ? (
              <img src={require("../Assets/Images/philoTest2.png")} alt="philoTest2" width="100%" height="auto" />
            ) : (
              <img src={require("../Assets/Images/philoTest.png")} alt="philoTest" width="100%" height="auto" />
            )}
          </Section2Image>
          <Section2MainCopy data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
            “ 기획에서 시작해 글로벌로 확장되는 미래적 비전 ”
          </Section2MainCopy>
        </Section2Container>
        <Section3Container>
          <Section2TitleCopy
            style={{ textAlign: isMobile ? "center" : "right", marginBottom: isMobile ? "0px" : "40px" }}
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="1400"
          >
            Our <StrokeText>Vision</StrokeText>
          </Section2TitleCopy>
          <Section3List>
            <Section3Item style={{ marginTop: isMobile ? "80px" : "0px" }} data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              <Section3LeftItem>
                <Section3ItemCategoryCopy style={{ marginBottom: "12px" }}>미래지향적 사고</Section3ItemCategoryCopy>
                <Section3ItemTitleCopy style={{ marginBottom: "24px" }}>
                  Future-Oriented
                  <br />
                  <StrokeText>Thinking</StrokeText>
                </Section3ItemTitleCopy>
                <Section3ItemTitleCopy style={{ fontSize: isMobile ? "16px" : "20px", fontWeight: "700", marginBottom: "8px" }}>
                  - 오늘의 전략으로 내일의 성공을 설계
                </Section3ItemTitleCopy>
                <Section3ItemTitleCopy style={{ fontSize: isMobile ? "16px" : "20px", fontWeight: "700" }}>
                  - 트렌드를 앞서가는 혁신적 아이디어 개발
                </Section3ItemTitleCopy>
              </Section3LeftItem>
              <Section3Image>
                <img src={aboutImg1} alt="aboutImg1" width="100%" height="auto" />
              </Section3Image>
            </Section3Item>
            <Section3Item style={{ marginTop: isMobile ? "80px" : "386px" }} data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              <Section3LeftItem>
                <Section3ItemCategoryCopy style={{ marginBottom: "12px" }}>창의적 우수성</Section3ItemCategoryCopy>
                <Section3ItemTitleCopy style={{ marginBottom: "24px" }}>
                  Creative <StrokeText>Excellence</StrokeText>
                </Section3ItemTitleCopy>
                <Section3ItemTitleCopy style={{ fontSize: isMobile ? "16px" : "20px", fontWeight: "700", marginBottom: "8px" }}>
                  - 독창적이고 차별화된 솔루션 제공
                </Section3ItemTitleCopy>
                <Section3ItemTitleCopy style={{ fontSize: isMobile ? "16px" : "20px", fontWeight: "700" }}>
                  - 예술과 기술이 융합된 크리에이티브
                </Section3ItemTitleCopy>
              </Section3LeftItem>
              <Section3Image>
                <img src={aboutImg2} alt="aboutImg2" width="100%" height="auto" />
              </Section3Image>
            </Section3Item>
            <Section3Item style={{ marginTop: isMobile ? "80px" : "0px" }} data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              <Section3LeftItem>
                <Section3ItemCategoryCopy style={{ marginBottom: "12px" }}>데이터 기반 혁신</Section3ItemCategoryCopy>
                <Section3ItemTitleCopy style={{ marginBottom: "24px" }}>
                  Data-Driven <StrokeText>Innovation</StrokeText>
                </Section3ItemTitleCopy>
                <Section3ItemTitleCopy style={{ fontSize: isMobile ? "16px" : "20px", fontWeight: "700", marginBottom: "8px" }}>
                  - 직감과 데이터의 완벽한 조화
                </Section3ItemTitleCopy>
                <Section3ItemTitleCopy style={{ fontSize: isMobile ? "16px" : "20px", fontWeight: "700" }}>
                  - 측정 가능한 성과와 지속적 개선
                </Section3ItemTitleCopy>
              </Section3LeftItem>
              <Section3Image>
                <img src={aboutImg3} alt="aboutImg3" width="100%" height="auto" />
              </Section3Image>
            </Section3Item>
            <Section3Item style={{ marginTop: isMobile ? "80px" : "386px" }} data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              <Section3LeftItem>
                <Section3ItemCategoryCopy style={{ marginBottom: "12px" }}>진정성 있는 파트너십</Section3ItemCategoryCopy>
                <Section3ItemTitleCopy style={{ marginBottom: "24px" }}>
                  Authentic <StrokeText>Partnership</StrokeText>
                </Section3ItemTitleCopy>
                <Section3ItemTitleCopy style={{ fontSize: isMobile ? "16px" : "20px", fontWeight: "700", marginBottom: "8px" }}>
                  - 고객의 성공이 우리의 성공
                </Section3ItemTitleCopy>
                <Section3ItemTitleCopy style={{ fontSize: isMobile ? "16px" : "20px", fontWeight: "700" }}>
                  - 투명하고 신뢰할 수 있는 협업
                </Section3ItemTitleCopy>
              </Section3LeftItem>
              <Section3Image>
                <img src={aboutImg4} alt="aboutImg4" width="100%" height="auto" />
              </Section3Image>
            </Section3Item>
          </Section3List>
        </Section3Container>
      </Section2BG>
      <Section4BG>
        <Section4Wraper>
          <Section4TitleContainer data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
            <Section4TitleCopy>우리가 미래를 만드는 방식</Section4TitleCopy>
            <Section4MainCopy>C2X Future Making {isMobile && <br />}Process™</Section4MainCopy>
          </Section4TitleContainer>
          {isMobile ? (
            <Section4ListContainer>
              <div style={{ display: "flex", width: "100%", marginBottom: "32px" }}>
                <Section4ListItem>
                  <Section4ListImage data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                    <img src={require("../Assets/Images/aboutList1.png")} alt="aboutList1" width="70%" maxWidth="167px" height="auto" />
                  </Section4ListImage>
                  <Section4ListText>
                    <Section4ListTitleCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                      CONCEPT 발굴
                    </Section4ListTitleCopy>
                    <Section4ListBodyCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                      브랜드 DNA와 미래 비전 탐색
                    </Section4ListBodyCopy>
                  </Section4ListText>
                </Section4ListItem>
                <Section4ListArrow data-aos="fade-right" data-aos-delay="100" data-aos-duration="1400">
                  {/* <img src={aboutArrow1} alt="aboutArrow1" width="100%" /> */}
                  <img src={aboutArrow2} alt="aboutArrow2" width="100%" />
                </Section4ListArrow>
                <Section4ListItem>
                  <Section4ListImage data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                    <img src={require("../Assets/Images/aboutList2.png")} alt="aboutList2" width="70%" maxWidth="167px" height="auto" />
                  </Section4ListImage>
                  <Section4ListText>
                    <Section4ListTitleCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                      CONCEPT 발굴
                    </Section4ListTitleCopy>
                    <Section4ListBodyCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                      브랜드 DNA와 미래 비전 탐색
                    </Section4ListBodyCopy>
                  </Section4ListText>
                </Section4ListItem>
              </div>
              <div style={{ display: "flex", width: "100%" }}>
                <Section4ListItem>
                  <Section4ListImage data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                    <img src={require("../Assets/Images/aboutList3.png")} alt="aboutList3" width="70%" maxWidth="167px" height="auto" />
                  </Section4ListImage>
                  <Section4ListText>
                    <Section4ListTitleCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                      CONCEPT 발굴
                    </Section4ListTitleCopy>
                    <Section4ListBodyCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                      브랜드 DNA와 미래 비전 탐색
                    </Section4ListBodyCopy>
                  </Section4ListText>
                </Section4ListItem>
                <Section4ListArrow data-aos="fade-right" data-aos-delay="100" data-aos-duration="1400">
                  <img src={aboutArrow2} alt="aboutArrow2" width="100%" />
                </Section4ListArrow>
                <Section4ListItem>
                  <Section4ListImage data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                    <img src={require("../Assets/Images/aboutList4.png")} alt="aboutList4" width="70%" maxWidth="167px" height="auto" />
                  </Section4ListImage>
                  <Section4ListText>
                    <Section4ListTitleCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                      CONCEPT 발굴
                    </Section4ListTitleCopy>
                    <Section4ListBodyCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                      브랜드 DNA와 미래 비전 탐색
                    </Section4ListBodyCopy>
                  </Section4ListText>
                </Section4ListItem>
              </div>
            </Section4ListContainer>
          ) : (
            <Section4ListContainer>
              <Section4ListItem>
                <Section4ListImage data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                  <img src={require("../Assets/Images/aboutList1.png")} alt="aboutList1" width="70%" maxWidth="167px" height="auto" />
                </Section4ListImage>
                <Section4ListText>
                  <Section4ListTitleCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                    CONCEPT 발굴
                  </Section4ListTitleCopy>
                  <Section4ListBodyCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                    브랜드 DNA와 미래 비전 탐색
                  </Section4ListBodyCopy>
                </Section4ListText>
              </Section4ListItem>
              <Section4ListArrow data-aos="fade-right" data-aos-delay="100" data-aos-duration="1400">
                <img src={aboutArrow1} alt="aboutArrow1" width="100%" />
                {/* <img src={aboutArrow2} alt="aboutArrow2" width="100%" /> */}
              </Section4ListArrow>
              <Section4ListItem>
                <Section4ListImage data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                  <img src={require("../Assets/Images/aboutList2.png")} alt="aboutList2" width="70%" maxWidth="167px" height="auto" />
                </Section4ListImage>
                <Section4ListText>
                  <Section4ListTitleCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                    CONCEPT 발굴
                  </Section4ListTitleCopy>
                  <Section4ListBodyCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                    브랜드 DNA와 미래 비전 탐색
                  </Section4ListBodyCopy>
                </Section4ListText>
              </Section4ListItem>
              <Section4ListArrow data-aos="fade-right" data-aos-delay="100" data-aos-duration="1400">
                <img src={aboutArrow1} alt="aboutArrow1" width="100%" />
                {/* <img src={aboutArrow2} alt="aboutArrow2" width="100%" /> */}
              </Section4ListArrow>
              <Section4ListItem>
                <Section4ListImage data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                  <img src={require("../Assets/Images/aboutList3.png")} alt="aboutList3" width="70%" maxWidth="167px" height="auto" />
                </Section4ListImage>
                <Section4ListText>
                  <Section4ListTitleCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                    CONCEPT 발굴
                  </Section4ListTitleCopy>
                  <Section4ListBodyCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                    브랜드 DNA와 미래 비전 탐색
                  </Section4ListBodyCopy>
                </Section4ListText>
              </Section4ListItem>
              <Section4ListArrow data-aos="fade-right" data-aos-delay="100" data-aos-duration="1400">
                <img src={aboutArrow1} alt="aboutArrow1" width="100%" />
                {/* <img src={aboutArrow2} alt="aboutArrow2" width="100%" /> */}
              </Section4ListArrow>
              <Section4ListItem>
                <Section4ListImage data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                  <img src={require("../Assets/Images/aboutList4.png")} alt="aboutList4" width="70%" maxWidth="167px" height="auto" />
                </Section4ListImage>
                <Section4ListText>
                  <Section4ListTitleCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                    CONCEPT 발굴
                  </Section4ListTitleCopy>
                  <Section4ListBodyCopy data-aos="fade-up" data-aos-delay="350" data-aos-duration="1400">
                    브랜드 DNA와 미래 비전 탐색
                  </Section4ListBodyCopy>
                </Section4ListText>
              </Section4ListItem>
            </Section4ListContainer>
          )}
        </Section4Wraper>
      </Section4BG>
      <Section5>
        <Section5Wraper>
          <Section2TitleCopy data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
            Our <StrokeText>Differentiation</StrokeText>
          </Section2TitleCopy>
          <Section5ImageContainer data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
            <Section5ImageItem>
              <Section5Image>
                <img src={require("../Assets/Images/aboutImg1.jpg")} alt="aboutImg1" />
              </Section5Image>
              <Section5TextArea>
                <Section5TextCopy>
                  체험단 플랫폼부터
                  <br />
                  커뮤니티 운영까지 직접 관리
                </Section5TextCopy>
              </Section5TextArea>
            </Section5ImageItem>
            <Section5ImageItem>
              <Section5Image>
                <img src={require("../Assets/Images/aboutImg2.jpg")} alt="aboutImg2" width="100%" height="auto" />
              </Section5Image>
              <Section5TextArea>
                <Section5TextCopy>
                  한 번 만든 콘텐츠를
                  <br />
                  모든 채널에 맞춰 재활용
                </Section5TextCopy>
              </Section5TextArea>
            </Section5ImageItem>
            <Section5ImageItem>
              <Section5Image>
                <img src={require("../Assets/Images/aboutImg3.jpg")} alt="aboutImg3" width="100%" height="auto" />
              </Section5Image>
              <Section5TextArea>
                <Section5TextCopy>
                  병원·한의원 등<br />
                  고관여 업종 마케팅 경험
                </Section5TextCopy>
              </Section5TextArea>
            </Section5ImageItem>
          </Section5ImageContainer>
        </Section5Wraper>
      </Section5>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  background-color: #000000;
  overflow: hidden;
`;

const TopSection = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  ${media.web`
      margin-top: 240px;
  `}
  ${media.mobile`
      margin-top: 136px;
  `}
`;

const TopSectionTitleArea = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transform: translateY(-50%);
`;

const TopSectionTitleContainer = styled.div`
  max-width: 1540px;
  padding: 0 20px;
  margin: 0 auto;
`;

const TopSectionTitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  ${media.web`
      font-size: ${fluidFont(72, 100)};
  `}
  ${media.mobile`
      font-size: 42px;
  `}
`;

const TopSectionBG = styled.div`
  background-attachment: fixed;
  background: url(${aboutTopBG}) no-repeat center / cover;
  width: 100%;
  ${media.web`
    height:500px;
  `};
  ${media.mobile`
    background-size: 200%;
    background-position: top 11% center;
    height:320px;
  `};
`;

const Section1Container = styled.div`
  width: 100%;
  position: relative;
  padding: 160px 0 150px;
`;

const Section1Title = styled.div`
  width: 100%;
  margin: 0;
  position: absolute;
  transform: translateX(-50%);
  z-index: 1;
  top: 43%;
  left: 50%;
  padding: 0 20px;
`;

const Section1TitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  text-align: center;
  font-weight: 800;
  ${media.web`
      font-size: ${fluidFont(32, 64)};
  `}
  ${media.mobile`
      font-size: 28px;
  `}
`;

const Section1BodyCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  text-align: center;
  font-weight: 500;
  ${media.web`
      font-size: ${fluidFont(16, 24)};
      margin-top:48px;
  `}
  ${media.mobile`
      font-size: 16px;
      margin-top:36px;
      line-height:1.35;
  `}
`;

const Section1CanvasWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  ${media.web`
    height: 800px;
  `}
  ${media.mobile`
    height: 300px;
  `}
`;

const Section1Canvas = styled.canvas`
  width: 1200px;
  box-sizing: border-box;
  ${media.web`
    height: 675px;
    aspect-ratio: 16 / 9;
    margin: 0 auto;
  `}
  ${media.mobile`
    display: block;
    width: 100%;
    
  `}
`;

const Section2BG = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: url(${aboutBg2}) no-repeat left top 5% / 55%;
`;

const Section2Container = styled.div`
  max-width: 1540px;
  padding: 0 20px;
  margin: 0 auto;
`;

const Section2TitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  padding: 0 20px;
  ${media.web`
    font-size: ${fluidFont(32, 64)};
    margin-bottom:80px;
  `}

  ${media.mobile`
  text-align:center;
    font-size: 32px;
    margin-bottom:40px;
  `}
`;

const Section2Image = styled.div`
  width: 100%;
  height: auto;
  max-width: 1540px;
`;

const Section2MainCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  text-align: center;
  font-weight: 700;
  ${media.web`
    font-size:  ${fluidFont(28, 40)};
    margin-top:100px;
  `}
  ${media.mobile`
    font-size: 20px;
    margin-top:24px;
  `}
`;

const Section3Container = styled.div`
  width: 100%;
  max-width: 1540px;
  margin: 0 auto;
  ${media.web`
  padding: 200px 0 100px;
  `}
  ${media.mobile`
   padding: 80px 0 100px;
`}
`;

const Section3List = styled.div`
  padding: 0 20px;
  ${media.web`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 200px 62px;
  `}
  ${media.mobile`
    display: flex;
    flex-direction: column;
  `}
`;

const Section3Item = styled.div``;

const Section3LeftItem = styled.div`
  ${media.web`
    text-align: left;
margin-bottom:100px;
  `}
  ${media.mobile`
    text-align: center;
margin-bottom:48px;
  `}
`;

const Section3Image = styled.div`
  width: 70%;
  max-width: 330px;
  ${media.web`
    margin-left: 60px;
  `}
  ${media.mobile`
    margin: 0 auto;
  `}
`;

const Section3ItemCategoryCopy = styled.div`
  color: #3da7ff;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  ${media.web`
    font-size: ${fluidFont(16, 24)};
    margin-top:12px;
  `}
  ${media.mobile`
    font-size: 16px;
  `}
`;

const Section3ItemTitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  line-height: 135%;
  ${media.web`
    font-size: ${fluidFont(32, 64)};
  `}
  ${media.mobile`
    font-size: 32px;
  `}
`;

const Section4BG = styled.div`
  width: 100%;
  background: url(${about4bg}) no-repeat center / cover;
  ${media.web`
    padding:260px 0;
  `}
  ${media.mobile`
    padding:100px 0;
  `}
`;

const Section4Wraper = styled.div`
  width: 100%;
  max-width: 1540px;
  padding: 0 20px;
  margin: 0 auto;
  box-sizing: border-box;
`;

const Section4TitleContainer = styled.div`
  text-align: center;
  ${media.web`
    margin-bottom: 80px;
  `}
  ${media.mobile`
    margin-bottom: 40px;
  `}
`;

const Section4TitleCopy = styled.div`
  color: #3da7ff;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  margin-bottom: 12px;
  ${media.web`
    font-size: ${fluidFont(16, 24)};
  `}
  ${media.mobile`
    font-size: 16px;
  `}
`;

const Section4MainCopy = styled.div`
  color: #ffffff;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  ${media.web`
    font-size: ${fluidFont(32, 64)};
  `}
  ${media.mobile`
    font-size: 32px;
  `}
`;

const Section4ListContainer = styled.div`
  display: flex;
  align-items: flex-start;
  overflow: hidden;
  ${media.web`
  gap: 0 16px;
  `}
  ${media.mobile`
  width:100%;
  flex-direction: column;
  flex-wrap: wrap;
  `}
`;

const Section4ListItem = styled.div`
  flex: 1;
  opacity: 1 !important;
`;

const Section4ListImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(rgba(84, 79, 79, 0.2), rgba(84, 79, 79, 0.05));
  border: solid 1px rgba(255, 255, 255, 0.25);
  border-radius: 20px;
  backdrop-filter: blur(30px);
  box-sizing: border-box;
  ${media.web`
    padding: 32px 24px;
  `}
  ${media.mobile`
    padding: 44px 0;
  `}
`;

const Section4ListText = styled.div`
  text-align: center;
  ${media.web`
    margin-top: 24px;
  `}
  ${media.mobile`
    margin-top: 16px;
  `}
`;

const Section4ListTitleCopy = styled.div`
  color: #ffffff;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  ${media.web`
    font-size: ${fluidFont(16, 24)};
  `}
  ${media.mobile`
    font-size: 16px;
  `}
`;

const Section4ListBodyCopy = styled.div`
  color: rgb(196, 196, 196);
  font-family: "Pretendard";
  font-style: normal;
  opacity: 0.7;
  font-weight: 700;
  ${media.web`
    font-size: ${fluidFont(14, 18)};
    margin-top:12px;
  `}
  ${media.mobile`
    font-size: 14px;
    margin-top:8px;
  `}
`;

const Section4ListArrow = styled.div`
  ${media.web`
    margin-top: 146.5px;
  `}
  ${media.mobile`
    margin: 100px 12px 0;
    width:24px;
  `}
`;

const Section5 = styled.div`
  width: 100%;
  ${media.web`
  padding: 100px 0 200px;
  `}
  ${media.mobile`
  padding: 100px 0 100px;
  `}
`;

const Section5Wraper = styled.div`
  max-width: 1540px;
  padding: 0 20px;
  margin: 0 auto;
`;

const Section5ImageContainer = styled.div`
  display: flex;
  gap: 20px;
  ${media.mobile`
    flex-direction: column;
  `}
`;

const Section5ImageItem = styled.div`
  border-radius: 20px;
  overflow: hidden;
  position: relative;

  &:hover img {
    transform: scale(1.05);
  }

  img {
    transition: transform 1s ease-in-out;
    display: block;
    width: 100%;
    height: auto;

    @media (max-width: 768px) {
      height: 100%;
      object-fit: cover;
    }
  }

  ${media.web``}
`;

const Section5Image = styled.div`
  overflow: hidden;
  width: 100%;
  ${media.mobile`
  aspect-ratio: 16 / 9;
  `}
`;

const Section5TextArea = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  padding: 0 20px;
  box-sizing: border-box;
`;

const Section5TextCopy = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  position: absolute;
  color: #ffffff;
  font-family: "Pretendard";
  font-style: normal;
  margin: 0;
  padding: 0;
  line-height: 1.5;

  ${media.web`
    font-weight: 700;
    font-size: ${fluidFont(14, 32)};
  `}
  ${media.mobile`
    font-weight: 800;
    font-size: 20px;
  `}
`;

const StrokeText = styled.span`
  -webkit-text-stroke: 1px #ffffff;
  color: transparent !important;
`;

const SquareText = styled.span`
  border-style: solid;
  border-width: 1px;
  border-color: #ffffff;
  border-radius: 5px;
  ${media.web`
  padding: 12px 24px;
  `}
  ${media.mobile`
  padding: 12px;
  `}
`;

export default About;
